import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading4, ButtonLink } from '@blueprint/ui';
export const ListingValuationContainer = styled('aside')((props) => {
    const {
        theme: { mq, spacing }
    } = props;
    return css`
        text-align: center;
        padding: ${spacing['32px']} 0 ${spacing['48px']};
        ${mq.medium} {
            ${ButtonLink} {
                max-width: 25rem;
            }
        }

        ${Heading4} {
            margin-bottom: ${spacing['8px']};
        }
    `;
});
